/* Source: /app/components/ui/Badge.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { cn } from "../../lib/utils.js";
function Badge(props) {
  let children = props.children;
  let variant = (props.variant || "neutral");
  let size = (props.size || "md");
  let className = (props.className || "");
  let sizeClasses = (((size === "sm") && "text-xs px-2 py-0.5") || "text-sm px-2.5 py-1");
  let variantClasses = ((((((((variant === "primary") && "bg-primary text-primary-foreground") || ((variant === "secondary") && "bg-secondary text-secondary-foreground")) || ((variant === "success") && "bg-success text-success-foreground")) || ((variant === "warning") && "bg-warning text-warning-foreground")) || ((variant === "error") && "bg-error text-error-foreground")) || ((variant === "info") && "bg-primary/15 text-primary")) || "bg-surface text-text-secondary border border-border");
  return __jacJsx("span", {"className": cn("inline-flex items-center font-medium rounded-md", sizeClasses, variantClasses, className)}, [children]);
}
export {Badge};